// extracted by mini-css-extract-plugin
export var mt0 = "widget-fast-facts-module--mt-0--1bfdc";
export var mt1 = "widget-fast-facts-module--mt-1--119f9";
export var mt2 = "widget-fast-facts-module--mt-2--1f0b0";
export var mt3 = "widget-fast-facts-module--mt-3--895b9";
export var mt4 = "widget-fast-facts-module--mt-4--7d77f";
export var mt5 = "widget-fast-facts-module--mt-5--1775c";
export var mt6 = "widget-fast-facts-module--mt-6--5d12c";
export var widgetFastFacts = "widget-fast-facts-module--widget-fast-facts--6a86b";
export var widgetFastFacts__eyebrow = "widget-fast-facts-module--widget-fast-facts__eyebrow--f16ea";
export var widgetFastFacts__logo = "widget-fast-facts-module--widget-fast-facts__logo--d6e35";
export var widgetFastFacts__statItem = "widget-fast-facts-module--widget-fast-facts__stat-item--2f180";
export var widgetFastFacts__statItem__copy = "widget-fast-facts-module--widget-fast-facts__stat-item__copy--1884d";
export var widgetFastFacts__statItem__headline = "widget-fast-facts-module--widget-fast-facts__stat-item__headline--c9c3f";